import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SectionHeading from "./sectionHeading";
import { useMediaQuery } from "react-responsive";

export default function ImageGridRectangular({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  return (
    <div id="imageGridRectangular">
      <SectionHeading title={content.title} subtitle={content.subtitle} />
      <div className="imageGridRectangular">
        {isMobile ? (
          <div className="wrapper">
            {[Math.floor((content.imageListMobile?.length + 2) / 2)]
              .map(it => {
                let tmp = [];
                for (let i = 0; i < it; i++) {
                  tmp.push(i);
                }
                return tmp;
              })[0]
              ?.map((gr, idxG) => {
                return (
                  <div className="imgGroup" key={idxG}>
                    {content.imageListMobile?.slice(gr * 2, gr * 2 + 2).map((image, i) => (
                      <div key={idxG + "_" + i} className="logo">
                        <LazyLoadImage alt="logo" effect="blur" src={image.media?.url} />
                      </div>
                    ))}
                  </div>
                );
              })}
          </div>
        ) : (
          content.imageListDesktop?.map((image, i) => (
            <LazyLoadImage key={i} alt="logo" effect="blur" src={image.media?.url} />
          ))
        )}
      </div>
    </div>
  );
}
